import { c as _c } from "react/compiler-runtime";
import type { BackupPolicyType, Condition } from '@repo/api-gw-sdk';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { showsClassificationCadence } from './classificationCadenceVisibility';

// The rollout gate, shared by every surface that mentions the cadence. The server refuses a cadence
// for a project that is not opted in, so a surface that skips the flag advertises work that cannot
// be saved.
export const useShowsClassificationCadence = (condition, policyType) => {
  const $ = _c(4);
  const {
    ShadowClassificationPolicy
  } = useFeatureFlags();
  let t0;
  if ($[0] !== ShadowClassificationPolicy || $[1] !== condition || $[2] !== policyType) {
    t0 = !!ShadowClassificationPolicy && showsClassificationCadence(condition, policyType);
    $[0] = ShadowClassificationPolicy;
    $[1] = condition;
    $[2] = policyType;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};